import { RNG } from './RNG';



export class CommonData {
  static isNumeric(value: any): boolean {
    return !isNaN(value - parseFloat(value));
  }
  static getBoolean(value: any): boolean {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }
  static nonnegativeMod(n, m) {
    return ((n % m) + m) % m;
  }
  /**
   * Funkcja sprawdza czy podana wartosc to liczba integer
   * @param value
   */
  static isIntValue(value) {
    // tslint:disable-next-line: triple-equals radix
    return !isNaN(value) && parseInt(value) == value && !isNaN(parseInt(value, 10));
  }

  static inRange(x, a, b) {
    return this.isIntValue(a) &&
      x >= a &&
      x <= b;
  }

  static shuffleArray(o, seed: number) {
    if (!seed)
      seed = new Date().getTime();
    const rng = new RNG(seed);
    for (let j, x, i = o.length; i; j = Math.floor(rng.nextFloat() * i), x = o[--i], o[i] = o[j], o[j] = x)
      ;
    return o;

  }
  static stringToArray(str: string) {
    const string = str,
      expr = /^\[.*\]$/;  // no quotes here
    if (expr.test(string))
      return str.replace(/\[/, '').replace(/\]/, '').split(', ');
    return str;
  }
  static genUniqueId() {
    const a = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // tslint:disable-next-line: no-bitwise triple-equals
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    return a;
  }

  static getRandomInt(min: number, max: number) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  static toFixed(value, precision) {
    const power = Math.pow(10, precision || 0);
    return String(Math.round(value * power) / power);
  }

  static roundWithoutTrailingZeroes(num, dp) {
    const numToFixedDp = Number(num).toFixed(dp);
    return Number(numToFixedDp);
  }

  static redirect(url) {
    const link = document.createElement('a');
    link.href = new URL(url).toString();
    link.click();
  }
  static uuid() {
    // http://www.ietf.org/rfc/rfc4122.txt
    /*jshint bitwise: false*/
    const s = [];
    const hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    // tslint:disable-next-line: no-bitwise
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    const uuid = s.join("");
    return uuid;
    /*jshint bitwise: true*/
  }

  static isMobile() {
    try {
      document.createEvent("TouchEvent");
      return true;
    } catch (e) {
      return false;
    }
  }
  static groupBy<T>(array: T[], keyProvider: (value: T) => string | number): { [key: string]: T[]; } | { [key: number]: T[]; } {
    return array.reduce((result, currentValue) => {
      const key = keyProvider(currentValue);
      (result[key] = result[key] || []).push(
        currentValue
      );
      return result;
    }, {});
  }
  static indexBy<T>(array: T[], keyProvider: (value: T) => string | number): { [key: string]: T; } | { [key: number]: T; } {
    return array.reduce((result, currentValue) => {
      result[keyProvider(currentValue)] = currentValue;
      return result;
    }, {});
  }

  static deepEquals(x, y) {
    if (x === y) {
      return true; // if both x and y are null or undefined and exactly the same
    } else if (!(x instanceof Object) || !(y instanceof Object)) {
      return false; // if they are not strictly equal, they both need to be Objects
    } else if (x.constructor !== y.constructor) {
      // they must have the exact same prototype chain, the closest we can do is
      // test their constructor.
      return false;
    } else {
      for (const p in x) {
        if (!x.hasOwnProperty(p)) {
          continue; // other properties were tested using x.constructor === y.constructor
        }
        if (!y.hasOwnProperty(p)) {
          return false; // allows to compare x[ p ] and y[ p ] when set to undefined
        }
        if (x[p] === y[p]) {
          continue; // if they have the same strict value or identity then they are equal
        }
        if (typeof (x[p]) !== 'object') {
          return false; // Numbers, Strings, Functions, Booleans must be strictly equal
        }
        if (!CommonData.deepEquals(x[p], y[p])) {
          return false;
        }
      }
      for (const p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
          return false;
        }
      }
      return true;
    }
  }

  /**
   * Dzieli tablice na grupy size elementow
   *
   */
  static chunk(array: any[], size: number): any[] {
    let index = 0;
    const arrayLength = array.length;
    const res = [];
    for (index = 0; index < arrayLength; index += size) {
      const myChunk = array.slice(index, index + size);
      res.push(myChunk);
    }
    return res;
  }

}
